/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  NotificationTemplateDto,
  NotificationTemplatesControllerCreateV1PathParameters,
  NotificationTemplatesControllerDeleteV1PathParameters,
  NotificationTemplatesControllerFindAllV1PathParameters,
  NotificationTemplatesControllerFindOneV1PathParameters,
  NotificationTemplatesControllerUpdateV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class NotificationTemplatesService {
  private readonly http = inject(HttpClient);
  /**
   * Creates a template
   */

  create<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: NotificationTemplatesControllerCreateV1PathParameters,
    notificationTemplateDto?: NotificationTemplateDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/${clientId}/notification-templates`, notificationTemplateDto);
  }
  /**
   * Returns a list of all templates
   */

  findAll<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: NotificationTemplatesControllerFindAllV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/${clientId}/notification-templates`);
  }
  /**
   * Deletes a template
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    templateId,
  }: NotificationTemplatesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/clients/v1/${clientId}/notification-templates/${templateId}`);
  }
  /**
   * Returns a template
   */

  findOne<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    templateId,
  }: NotificationTemplatesControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/${clientId}/notification-templates/${templateId}`);
  }
  /**
   * Updates the template
   */

  update<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, templateId }: NotificationTemplatesControllerUpdateV1PathParameters,
    notificationTemplateDto?: NotificationTemplateDto,
  ): Observable<TData> {
    return this.http.put<TData>(`/clients/v1/${clientId}/notification-templates/${templateId}`, notificationTemplateDto);
  }
}
